/* eslint max-len: ["error", { "code": 140 }] */
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import AppStoreButton from '@fenderdigital/react-ui-kit/app-store-button';
import rems from '../../utils/rems-utils';

const messages = defineMessages({
  downloadThe: {
    id: 'tunerApps.downloadThe',
    defaultMessage: 'Download the {free} Fender Tune {tm} app',
  },
  includes: {
    id: 'tunerApps.includes',
    defaultMessage: 'Includes tuning for guitar, bass and ukulele.',
  },
});

const supStyles = {
  left: rems('-6px'),
  marginRight: rems('-9px'),
  top: rems('-5px'),
};

const TunerApps: React.FC = () => (
  <div className="tuner-apps" data-id="tuner-apps">
    <h3 className="pa0 ma0 futura-heavy f5 f3-ns tc tl-ns">
      <FormattedMessage
        {...messages.downloadThe}
        values={{
          free: <span className="red">free</span>,
          tm: <sup style={supStyles}>&trade;</sup>,
        }}
      />
    </h3>
    <p className="bb b--light-gray mb3 pb3 tc tl-ns f6">
      <FormattedMessage {...messages.includes} />
    </p>
    <div className="mb5 mb4-ns tc tl-ns">
      <AppStoreButton
        variant="apple"
        className="blue mr2"
        link="https://app.adjust.com/91o4yf2?redirect=https%3A%2F%2Fitunes.apple.com%2Fus%2Fapp%2Fid1107017950"
      />
      <AppStoreButton
        variant="google"
        className="blue"
        link="https://app.adjust.com/91o4yf2?redirect=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.fender.tuner"
      />
    </div>
  </div>
);

export default TunerApps;
